import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'pricing-plan',
    templateUrl: './pricing-plan.component.html',
    styleUrls: ['./pricing-plan.component.scss']
})
export class PricingPlanComponent implements OnInit {

    get isMobile(): boolean { return window.innerWidth < 500;}

    @Input() planName: string;
    @Input() header: {
        imgPath: string,
        name: string,
        price: string,
        pricePeriod: string,
        headerColor: string
    }
    @Input() body: {
        content: Array<Array<string>>;
    }
    @Output() planClick = new EventEmitter();
    constructor() { }

    ngOnInit() {
    }

    // NGStyle for header color
    getHeaderStyle() {
        return {
            'background-color': this.header.headerColor
        }
    }

    getNameStyle() {
        // if (this.isMobile) {
        //     return { 'font-size'}
        // }
        // else {
        //     return {}
        // }
        return null;
    }
}
